// Action Types
export const FETCH_FORM_STARTED = "FETCH_FORM_STARTED";
export const FETCH_FORM_ERROR = "FETCH_FORM_ERROR";
export const CHECK_FORM_AVAILABILITY = "CHECK_FORM_AVAILABILITY";

export const FETCH_FORM_INSTANCES_SUCCESS = "FETCH_FORM_INSTANCES_SUCCESS";
export const FETCH_FORM_FIELDS_SUCCESS = "FETCH_FORM_FIELDS_SUCCESS";
export const FETCH_FORM_DATA_SUCCESS = "FETCH_FORM_DATA_SUCCESS";

export const PUT_FORM_DATA = "PUT_FORM_DATA";
export const POST_FORM_DATA = "POST_FORM_DATA";
export const DELETE_FORM_DATA = "DELETE_FORM_DATA";
// Data types
export type FormDataItem = {
    id: number | string,
    htmltype: string,
    name?:string,
    label?:string,
    items?:any[],
    defaultChecked?:boolean,
    defaultValue?:any,
    placeholder?:string,
    value?: any,
    real_value?: any,
    disabled? : boolean,
    required?: boolean,
    error?: boolean,
}
export type FormData = {
    id: number,
    items: FormDataItem[],
    signature?: any
}
export type Column = {
    title: string,
    dataIndex: string
}
export interface Form {
    id: number,
    title: string,
    description: string,
    formFields: FormDataItem[],   // form structure
    formDatas: FormData[],
    columns: Column[],         // used for table
    dataSource:any[],          // used for table
}
//Reducer State Type
export interface FormsState {
    forms: Form[],
    isFetching: boolean,
    error?: any
}
// Action Data Types
///// GERNERAL REQUEST STATUS HANDLER
export interface FetchFormActionStarted {
    type: typeof FETCH_FORM_STARTED
}
export interface FetchFormActionError {
    type: typeof FETCH_FORM_ERROR
    error: any
}
///// GERNERAL RESPONSES HANDLER
export interface FetchFormInstancesActionSuccess {
    type: typeof FETCH_FORM_INSTANCES_SUCCESS
    formId: number,
    formTitle: string,
    description: string,
    columns: Column[],
    dataSource:any[],
}
export interface FetchFormFieldsActionSuccess {
    type: typeof FETCH_FORM_FIELDS_SUCCESS
    formId: number,
    formTitle: string,
    description: string,
    formFields: FormDataItem[],
}
export interface FetchFormDataActionSuccess {
    type: typeof FETCH_FORM_DATA_SUCCESS
    id: number,
    formTitle?: string, 
    formId: number,
    formDataFields: FormDataItem[],
    signature?: any
}
///// GERNERAL REQUESTS
export interface PutFormDataAction {
    type: typeof PUT_FORM_DATA,
    id: number,
    formId: number,
    formData: any,
}
export interface PostFormDataAction {
    type: typeof POST_FORM_DATA,
    formId: number,
    formData: any,
}
export interface DeleteFormDataAction {
    type: typeof DELETE_FORM_DATA,
    id: number,
    formId: number,
}
export type FormsActionTypes = FetchFormActionStarted | FetchFormActionError | FetchFormInstancesActionSuccess | FetchFormFieldsActionSuccess | FetchFormDataActionSuccess | PutFormDataAction | PostFormDataAction | DeleteFormDataAction;